var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEditorTextColor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 11.25V5.41667C7.0835 4.64312 7.39079 3.90125 7.93777 3.35427C8.48475 2.80729 9.22661 2.5 10.0002 2.5C10.7737 2.5 11.5156 2.80729 12.0626 3.35427C12.6095 3.90125 12.9168 4.64312 12.9168 5.41667V11.25M7.0835 6.875H12.9168",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6665,
    y: 15,
    width: 16.6667,
    height: 3.33333,
    rx: 1,
    fill: "#7A7A7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEditorTextColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-editor-text-color.e4b7ca822b32d44d25ae37c9a82f3e01.svg";